import React, { Component } from 'react';
import './Gallery.css';
import Nav from '../../nav/Nav';
import Back from '../../Back';
import User from '../../../User';
import Img from '../../../StableImage';
import Library from '../../../scene/utility/Library';
import characters from '../../../library/images.json';
import CutsceneManager from '../../../scene/CutsceneManager';
import Cutscene from '../../../scene/view/Cutscene';
//import allcards from '../../../library/cards.json';
import sourceallcutscenes from '../../../library/cutscenes.json';
import { localizeContent, translate, plainText } from '../../../ContentTranslation';
import sourceImages from '../../../library/gallery.json';

import { read, getLanguage } from '../../../TextManager';

const allcutscenes = localizeContent(sourceallcutscenes);
const allimages = localizeContent(sourceImages);

const champions = Library.champions;
const allcards = Library.rawcards;
const enemyAreas = ["ruins", "forest", "snow", "cave"];

function formatArea(area) {
  return translate(area.charAt(0).toUpperCase() + area.slice(1));
}

function getEnemyHp(enemy) {
  return Array.isArray(enemy.hp) ? enemy.hp[0] : enemy.hp;
}

function getEnemyStage(enemy) {
  return enemy.stage === undefined ? Infinity : enemy.stage;
}

function formatHp(hp) {
  if (Array.isArray(hp)) {
    if (hp[0] === hp[1])
      return hp[0];
    return hp[0] + "-" + hp[1];
  }
  return hp;
}

function formatEffect(effect) {
  return plainText(effect);
}

function getTranslatedValue(entry, field) {
  if (entry.translations) {
    const lang = getLanguage();
    return (entry.translations[lang] && entry.translations[lang][field])
      || (entry.translations.en && entry.translations.en[field])
      || entry[field];
  }
  return entry[field];
}

function getKnownFightEnemies(fight) {
  const enemies = (fight.slots || []).map(slot => slot.enemy).filter(Boolean);
  if (enemies.length === 0 || (!User.debugShowAllCollection && enemies.some(enemy => !User.knows("enemies", enemy))))
    return null;
  return enemies;
}

function countEnemies(enemies) {
  return enemies.reduce((counts, enemy) => {
    counts[enemy] = (counts[enemy] || 0) + 1;
    return counts;
  }, {});
}

function formatEnemyCount(enemy, count) {
  const model = Library.enemies[enemy];
  const name = model ? getTranslatedValue(model, "name") : enemy;
  return count > 1 ? name + " x" + count : name;
}

function formatEnemyList(enemies) {
  if (enemies.length <= 2)
    return enemies.join(translate(" and "));
  return enemies.slice(0, -1).join(", ") + translate(" and ") + enemies[enemies.length - 1];
}

function formatStatus(status) {
  const model = Library.statuses[status.key];
  const name = model ? getTranslatedValue(model, "name") : status.key;
  return status.value === 1 ? name : name + " x" + status.value;
}

function getStatusList(enemy) {
  return (enemy.states || []).filter(status => status && status.key && status.value).map(status => formatStatus(status));
}

function getPatternEffects(enemy) {
  return (enemy.patterns || []).map(pattern => formatEffect(pattern.effect)).filter(Boolean);
}

function getCanAppearWith(enemyKey) {
  const appearWith = new Set();
  let alone = false;

  Object.values(Library.acts).forEach(act => {
    Object.values(act.fights || {}).flat().forEach(fight => {
      const enemies = getKnownFightEnemies(fight);
      if (!enemies || !enemies.includes(enemyKey))
        return;

      if (enemies.length === 1) {
        alone = true;
        return;
      }

      const counts = countEnemies(enemies);
      counts[enemyKey] -= 1;
      const fightEnemies = Object.entries(counts).filter(([, count]) => count > 0).map(([enemy, count]) => formatEnemyCount(enemy, count));
      if (fightEnemies.length > 0)
        appearWith.add(formatEnemyList(fightEnemies));
    });
  });

  return (alone ? [translate("Alone")] : []).concat(Array.from(appearWith));
}

function getCupSize(cdInCm) {
    if (cdInCm < 2.5) return "AA";

    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const index = Math.floor((cdInCm - 2.5) / 2.5);
    return letters[index];
}

export default class Gallery extends Component {

  cutsceneManager = new CutsceneManager(null, c => this.setState({cutscene: c ? Object.assign({}, this.state.cutscene, c) : null}))

  state = {
    type: "portraits",
    cutscene: null
  }

  render () {

    let premium = User.premium;
    const softMode = User.isFetishSoft(User.champion);

    let cutscenes = Object.values(allcutscenes).filter(cutscene => cutscene.champion === -1 || cutscene.champion === User.champion && (!isNaN(cutscene.value) || !cutscene.value.endsWith("fast"))).sort((a, b) => a.key - b.key);

    let images = this.state.type === "portraits" ? Object.values(allimages[User.champion][this.state.type]).sort((a, b) => a.order - b.order) : null;
    let enemySections = [];

    if (this.state.type === "cards")
      images = Object.values(allcards).filter(c => c.champion === User.champion && !c.token).map(c => {
        return {
          title: getTranslatedValue(c, "name"),
          key: c.key,
          order: c.key,
          img: (User.debugShowAllCollection ? Library.cardArts(c) : Library.getUnlockedCardArts(c)).map(i => i.img),
          check: c.level === 1 ? { knows: c.key } : { level: c.level, knows: c.key }
        }
      })

    if (this.state.type === "enemies") {
      const enemies = Object.values(Library.enemies)
        .filter(e => e && e.key)
        .map(e => Library.getUpgradedEnemy(e.key, User.difficulty))
        .filter(Boolean);
      const companions = Object.values(Library.companions);
      const mapEnemy = (e, areaTitle, params={}) => {
        const canAppearWith = params.canAppearWith === false ? null : getCanAppearWith(e.key);
        const includeCombatInfo = params.combatInfo !== false;
        return {
          title: getTranslatedValue(e, "name"),
          key: e.key,
          order: 1,
          img: e.img,
          check: true,
          area: e.area,
          areaTitle,
          power: e.power,
          categoryLabel: params.categoryLabel,
          hp: includeCombatInfo ? formatHp(e.hp) : null,
          statuses: includeCombatInfo ? getStatusList(e) : [],
          patternEffects: includeCombatInfo ? getPatternEffects(e) : [],
          description: includeCombatInfo ? getTranslatedValue(e, "description") : null,
          skillEffect: params.skillEffect,
          actionEffect: params.actionEffect,
          canAppearWith
        }
      };
      enemySections = enemyAreas.map(area => {
        return {
          area,
          title: formatArea(area),
          images: enemies.filter(e => e.area === area && (e.power === 1 || e.power === 2) && (User.debugShowAllCollection || User.knows("enemies", e.key))).sort((a, b) => a.power - b.power || getEnemyHp(a) - getEnemyHp(b)).map(e => mapEnemy(e, formatArea(e.area)))
        }
      }).concat({
        area: "story",
        title: translate("Story"),
        images: enemies.filter(e => e.champion === User.champion && (User.debugShowAllCollection || User.knows("enemies", e.key))).sort((a, b) => getEnemyStage(a) - getEnemyStage(b) || getEnemyHp(a) - getEnemyHp(b)).map(e => mapEnemy(e, translate("Story"), { categoryLabel: translate("[name]'s story").replace('[name]', champions[User.champion].name), canAppearWith: false }))
      }).concat({
        area: "companions",
        title: translate("Companions"),
        images: companions.filter(c => c.champion === User.champion && (User.debugShowAllCollection || User.knows("enemies", c.key))).map(c => mapEnemy(c, translate("Companions"), {
          categoryLabel: translate("[name]'s companion").replace('[name]', champions[User.champion].name),
          skillEffect: c.skill && formatEffect(c.skill.effect),
          actionEffect: c.action && formatEffect(c.action.effect),
          combatInfo: false,
          canAppearWith: false
        }))
      }).filter(section => section.images.length);
      images = enemySections.flatMap(section => section.images);
    }

    if (images)
      images.forEach(image => image.unlocked = User.debugShowAllCollection || !image.check || Object.keys(image.check).every(key => {
        let value = image.check[key];
        switch (key) {
        case "hasSeen": return User.hasSeen(value);
        case "level": return User.data.level >= value;
        case "knows": return User.knows("cards", image.check.knows);
        default: return false;
        }
      }))

    let unlockedImages = [];
    if (this.state.type !== "scenes")
      unlockedImages = images.filter(i => i.unlocked);

    let left = null;
    let right = null;

    if (this.state.nofocus !== null && this.state.nofocus !== undefined) {

      const unlockedIndex = this.state.nofocus;
      if (unlockedIndex > 0) {
        left = images.filter(i => unlockedImages[unlockedIndex-1].key === i.key)[0];
      }
      if (unlockedIndex < unlockedImages.length-1) {
        right = images.filter(i => unlockedImages[unlockedIndex+1].key === i.key)[0];
      }
    }

    const renderImage = image =>
      <div
      key={"champion-" + User.champion + "-image-" + this.state.type + "-" + image.key}
      className={"gallery-image" + (this.state.type === "enemies" ? " gallery-image-enemy" : "") + (softMode && this.state.type === "portraits" ? " gallery-soft-preview" : "") + (image.unlocked ? "" : " locked")}
      onClick={image.unlocked ? () => this.setState({focus: image, nofocus: unlockedImages.findIndex(im => image.key === im.key), imgfocus: 0}) : () => {}}
      >
        { image.unlocked ?
          <Img src={Array.isArray(image.img) ? image.img[0] : image.img}/> :
          <div>
            { image.requirement && <div className="gallery-image-requirement">{image.requirement}</div> }
            <Img src="/images/locked.png"/>
          </div>
        }
      </div>

    return (
      <div className={"main-page gallery-page champion-" + User.champion}>
        <div className="main-background">
          <img src="/images/background.png"/>
        </div>
        <Nav onChangeDifficulty={() => this.forceUpdate()}/>
        {
          this.state.focus && 
          <div className="lightbox-container">
            <div className="lightbox-inner" onClick={() => this.setState({focus: null, nofocus: null})}>
              <div className={"gallery-lightbox" + (this.state.type === "enemies" ? " gallery-lightbox-enemy" : "") + (softMode && this.state.type === "portraits" ? " gallery-soft-focus" : "")}>
                <div className="gallery-lightbox-description">
                  <div className="gallery-description-section gallery-image-title">{this.state.focus.title}</div>
                  { this.state.type !== "enemies" ? <div className="gallery-description-section"><b>{translate("Champion: ")}</b>{champions[User.champion].name}</div> : "" }
                  { this.state.type === "enemies" && this.state.focus.categoryLabel ? <div className="gallery-description-section"><b>{this.state.focus.categoryLabel}</b></div> : "" }
                  { this.state.type === "enemies" && !this.state.focus.categoryLabel ? <div className="gallery-description-section"><b>{translate("Area: ")}</b>{this.state.focus.areaTitle}</div> : "" }
                  { this.state.type === "enemies" && this.state.focus.power ? <div className="gallery-description-section"><b>{translate("Power: ")}</b>{this.state.focus.power}</div> : "" }
                  { this.state.type === "enemies" && this.state.focus.hp !== null && this.state.focus.hp !== undefined ? <div className="gallery-description-section"><b>{translate("HP: ")}</b>{this.state.focus.hp}</div> : "" }
                  { this.state.type === "enemies" && this.state.focus.statuses && this.state.focus.statuses.length ? <div className="gallery-description-section"><b>{translate("Statuses: ")}</b>{this.state.focus.statuses.join(", ")}</div> : "" }
                  { this.state.type === "enemies" && this.state.focus.canAppearWith && this.state.focus.canAppearWith.length ? <div className="gallery-description-section"><b>{translate("Can appear with: ")}</b>{this.state.focus.canAppearWith.join(", ")}</div> : "" }
                  { this.state.type === "enemies" && this.state.focus.patternEffects && this.state.focus.patternEffects.length ? <div className="gallery-description-section gallery-pattern-effects"><b>{translate("Patterns:")}</b><ul>{this.state.focus.patternEffects.map((effect, i) => <li key={"pattern-effect-" + i}>{effect}</li>)}</ul></div> : "" }
                  { this.state.type === "enemies" && this.state.focus.skillEffect ? <div className="gallery-description-section"><b>{translate("Skill: ")}</b>{this.state.focus.skillEffect}</div> : "" }
                  { this.state.type === "enemies" && this.state.focus.actionEffect ? <div className="gallery-description-section"><b>{translate("Action: ")}</b>{this.state.focus.actionEffect}</div> : "" }
                  { this.state.focus.requirement ? <div className="gallery-description-section"><b>{translate("Requirement: ")}</b>{this.state.focus.requirement}</div> : "" }
                  { this.state.focus.height ? <div className="gallery-description-section"><b>{translate("Height: ")}</b>{(this.state.focus.height >= 100 ? (this.state.focus.height/100) + "m" : this.state.focus.height + "cm") + " / " + Math.floor(this.state.focus.height * 0.0328084) + "'" + Math.floor((this.state.focus.height * 0.0328084 - Math.floor(this.state.focus.height * 0.0328084)) * 12) + "\""}</div> : "" }
                  { this.state.focus.dick ? <div className="gallery-description-section"><b>{translate("Dick size: ")}</b>{(this.state.focus.dick >= 100 ? (this.state.focus.dick/100) + "m" : this.state.focus.dick + "cm") + " / " + Math.floor(this.state.focus.dick * 0.0328084) + "'" + Math.floor((this.state.focus.dick * 0.0328084 - Math.floor(this.state.focus.dick * 0.0328084)) * 12) + "\""}</div> : "" }
                  { this.state.focus.bust ? <div className="gallery-description-section"><b>{translate("Bust size: ")}</b>{(this.state.focus.bust >= 100 ? (this.state.focus.bust/100) + "m" : this.state.focus.bust + "cm") + " / " + Math.floor(this.state.focus.bust * 0.0328084) + "'" + Math.floor((this.state.focus.bust * 0.0328084 - Math.floor(this.state.focus.bust * 0.0328084)) * 12) + "\"" + (getCupSize(this.state.focus.bust) ? " (" + getCupSize(this.state.focus.bust) + ")" : "")}</div> : "" }
                  { this.state.focus.hips ? <div className="gallery-description-section"><b>{translate("Hips size: ")}</b>{(this.state.focus.hips >= 100 ? (this.state.focus.hips/100) + "m" : this.state.focus.hips + "cm") + " / " + Math.floor(this.state.focus.hips * 0.0328084) + "'" + Math.floor((this.state.focus.hips * 0.0328084 - Math.floor(this.state.focus.hips * 0.0328084)) * 12) + "\""}</div> : "" }
                  { this.state.focus.lift ? <div className="gallery-description-section"><b>{translate("Deadlift: ")}</b>{(this.state.focus.lift) + "kg" + " / " + Math.floor(this.state.focus.lift * 2.20462) + "lbs"}</div> : "" }
                  { this.state.focus.description ? <div className="gallery-description-section description">{this.state.focus.description}</div> : "" }
                </div>
                <div className="gallery-lightbox-image">
                  <Img
                    key={Array.isArray(this.state.focus.img) ? this.state.focus.img[this.state.imgfocus] : this.state.focus.img}
                    src={Array.isArray(this.state.focus.img) ? this.state.focus.img[this.state.imgfocus] : this.state.focus.img}
                    />
                  {
                    Array.isArray(this.state.focus.img) &&
                    <div className="gallery-lightbox-select-emotion">
                    {
                      this.state.focus.img.map((img, i) => <div key={"emotion-" + i} className={"gallery-lightbox-option-emotion" + (this.state.imgfocus === i ? " selected" : "")} onClick={e => {this.setState({imgfocus: i}); e.stopPropagation(); }}/>)
                    }
                    </div>
                  }
                </div>
                { left ? <div onClick={e => {this.setState({focus: left, nofocus: this.state.nofocus-1, imgfocus: 0}); e.stopPropagation(); }} className="cardbox-arrow cardbox-arrow-left"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
                { right ? <div onClick={e => {this.setState({focus: right, nofocus: this.state.nofocus+1, imgfocus: 0}); e.stopPropagation(); }} className="cardbox-arrow cardbox-arrow-right"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
              </div>
            </div>
          </div>
        }
        <div className="main">
          <div className="cards-page-nav"/>
          <div className="gallery">
            <div className="gallery-sidebar">
              <div className="gallery-sidebar-inner">
                <div className="gallery-champion-select gallery-type-select">
                {
                  ["portraits", "cards", "scenes", "enemies"].map(type =>
                    <div key={type} className={"gallery-champion-option" + (type === this.state.type ? " selected" : "")} onClick={() => this.setState({type})}>
                      <Img src={"/images/" + type + ".png"}/>
                    </div>
                  )
                }
                </div>
              </div>
            </div>
            <div className="gallery-main">
              <div className="gallery-image-list">
                {
                  this.state.type === "scenes" ?
                    cutscenes.filter(cutscene => User.canAccessCutscene(cutscene)).map((cutscene, i) =>
                      <div
                      key={"champion-" + User.champion + "-image-" + this.state.type + "-" + cutscene.key}
                      className={"gallery-video gallery-image" + (User.debugShowAllCollection || User.hasSeen(cutscene.key) ? "" : " locked")}
                      onClick={User.debugShowAllCollection || User.hasSeen(cutscene.key) ? () => {
                        this.cutsceneManager.callback = () => this.setState({cutscene: null})
                        this.cutsceneManager.start(cutscene);
                      } : () => {}}
                      >
                        {User.debugShowAllCollection || User.hasSeen(cutscene.key) ?
                          <div>
                            { cutscene.name && <div className="gallery-image-name">{cutscene.name}</div> }
                            <Img src={characters[cutscene.character] || "/images/locked.png"}/>
                          </div> :
                          <div id={cutscene.name}>
                            { cutscene.requirement && <div className="gallery-image-requirement">{cutscene.requirement}</div> }
                            <Img src="/images/locked.png"/>
                          </div>
                        }
                      </div>
                    )
                    /*cutscenes.map(cutscene =>
                      <div key={cutscene.key} className="gallery-cutscene"
                      onClick={() => {
                        this.cutsceneManager.callback = () => this.setState({cutscene: null})
                        this.cutsceneManager.start(cutscene);
                      }
                      }>
                      { cutscene.name }
                      </div>
                    )*/:
                  this.state.type === "enemies" ?
                    enemySections.map((section, sectionIndex) =>
                      <React.Fragment key={"enemy-section-" + section.area}>
                        { sectionIndex > 0 ? <div className="gallery-enemy-section-separator"/> : "" }
                        <div className="gallery-enemy-section-title">{section.title}</div>
                        { section.images.map((image, imageIndex) =>
                          <React.Fragment key={"enemy-" + image.key}>
                            { imageIndex > 0 && section.images[imageIndex-1].power !== image.power ? <div className="gallery-enemy-power-separator"/> : "" }
                            { renderImage(image) }
                          </React.Fragment>
                        ) }
                      </React.Fragment>
                    ) :
                    images.map(image => renderImage(image))
                }
              </div>
            </div>
          </div>
        {/*
          <div className="gallery">
            {
              cutscenes.map(cutscene =>
                <div key={cutscene.key} className="gallery-cutscene"
                onClick={() => {
                  this.cutsceneManager.callback = () => this.setState({cutscene: null})
                  this.cutsceneManager.start(cutscene);
                }
                }>
                { cutscene.name }
                </div>
              )
            }
          </div>
          */}
          {
            this.state.cutscene ?
            <Cutscene back={() => this.cutsceneManager.back()} skip={() => this.cutsceneManager.skip()} continue={() => this.cutsceneManager.continue()} src={this.state.cutscene}/> : ""
          }
        </div>
        <Back to="/play"/>
      </div>
    );
  }
}
